import React, { useEffect, useState } from 'react';
import { OverlayTrigger, Popover, Button, Modal, Col, Form, Row } from 'react-bootstrap';
import { configData } from '../../config/systemconfigurationconstants';
import * as AWS from 'aws-sdk';
import { useNavigate } from 'react-router-dom';
import { useEncryption } from '../../customHooks/useEncryption';
const ResetDashboardLoan = ({ show, handleClose, rowDetailsforResetLoans }) => {
    const { encrypt, decrypt } = useEncryption();
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return decodeURIComponent(parts.pop().split(';').shift());
    }
    return null;
  };
    // AWS Key Details
    const lambda = new AWS.Lambda({
        region: configData.LAMBDA_REGION,
        accessKeyId: decrypt(getCookie('ak')),
secretAccessKey: decrypt(getCookie('sk'))
    });
    // For navigation
    const navigate = useNavigate();
    // console.log(rowDetailsforResetLoans)
    const [statusForReset, setStatusForReset] = useState("");
    const [resetFailMessage, setResetFailMessage] = useState("");
    const [showResetFailMessage, setShowResetFailMessage] = useState(false);
    const resetOrderForLoan = () =>{
        const data = {
            "Command": configData.RESET_LOAN_STATUS,
            "LoanGuid": rowDetailsforResetLoans.LG,
            "InternalStatus": statusForReset,
            "ExternalStatus": statusForReset,
            "SecurityId": null,
            "SecurityToken": localStorage.getItem("SecurityToken"),
            "EventContextId": null,
            "CallerSourceId": null,
            "CallerSourceName": null
        };

        const params = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(data)
        };

        lambda.invoke(params, (err, data) => {
            if (err) {
                console.log(err, err.stack);
            } else {
                let lambdaResponse = JSON.parse(data.Payload.toString());
                lambdaResponse = JSON.parse(lambdaResponse.body);
                let responseOutput = JSON.parse(lambdaResponse.Output);
                if (lambdaResponse.Status == true) {
                    setShowResetFailMessage(false)
                    // toast.success("Loan reset successfully", {
                    //     position: "bottom-center",
                    //     autoClose: 2000,
                    //     hideProgressBar: true,
                    //     closeOnClick: true,
                    //     pauseOnHover: true,
                    //     draggable: true,
                    //     progress: undefined,
                    //     theme: "colored",
                    // });
                    handleClose();
                    // Add a 2-second delay before navigation
                    setTimeout(() => {
                        navigate('/dashboard');
                    }, 2000);

                } else {
                    setResetFailMessage(responseOutput["Task Message"])
                    setShowResetFailMessage(true)
                }
            }
        })
    }
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Loan Reset</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p><i class="ri-error-warning-fill"></i> Do you want to reset the Loan - {rowDetailsforResetLoans?.LN}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" size='sm' onClick={resetOrderForLoan}>
                    Yes
                </Button>
                <Button variant="primary" size='sm' onClick={handleClose}>
                    No
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
export default ResetDashboardLoan